import { render, staticRenderFns } from "./UpdateOrCreateAccessPointComponent.vue?vue&type=template&id=38da83c7&scoped=true"
import script from "./UpdateOrCreateAccessPointComponent.vue?vue&type=script&lang=js"
export * from "./UpdateOrCreateAccessPointComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da83c7",
  null
  
)

export default component.exports